import { gql } from '@apollo/client'

export const CREATE_ACTIVITY_MUTATION = gql`
  mutation CREATE_ACTIVITY_MUTATION($input: LogCreateInput!) {
    logCreate(input: $input) {
      ok
    }
  }
`

export const DELETE_ACTIVITY_MUTATION = gql`
  mutation DELETE_ACTIVITY_MUTATION($id: ID!) {
    logDelete(id: $id) {
      ok
    }
  }
`

export const EDIT_ACTIVITY_MUTATION = gql`
  mutation EDIT_ACTIVITY_MUTATION($id: ID!, $input: LogUpdateInput!) {
    logUpdate(id: $id, input: $input) {
      ok
    }
  }
`
